import { render, staticRenderFns } from "./DisclaimerPopup.vue?vue&type=template&id=6649c27c&scoped=true&"
import script from "./DisclaimerPopup.vue?vue&type=script&lang=js&"
export * from "./DisclaimerPopup.vue?vue&type=script&lang=js&"
import style0 from "./DisclaimerPopup.vue?vue&type=style&index=0&id=6649c27c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6649c27c",
  null
  
)

export default component.exports